import { MarkMotif } from "@mineoptics/brand/logo";
import { PillLink } from "./PillLink";
import { DOCS_URL, SIGNUP_URL } from "@/lib/site";

interface Props {
  title?: string;
  body?: string;
}

/** Closing call to action used on the inner pages. */
export function CtaBand({
  title = "Start with one site.",
  body = "Free for 7 days with every module: a project and a site of your own, and a sample study to look around in. No card.",
}: Props) {
  return (
    <section data-theme="dark" className="relative overflow-hidden bg-bg">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(70%_80%_at_85%_100%,rgba(203,255,84,0.1),transparent_65%)]" />
      <MarkMotif className="pointer-events-none absolute -right-[26rem] top-1/2 h-[46rem] w-[46rem] -translate-y-1/2 text-fg/20 md:-right-[23rem]" />
      <div className="shell relative flex flex-col gap-10 py-28 md:flex-row md:items-end md:justify-between md:py-40">
        <h2 data-split className="title max-w-[12ch]">
          {title}
        </h2>
        <div data-fade className="max-w-md">
          <p className="lede text-fg/75">{body}</p>
          <div className="mt-7 flex flex-wrap gap-3">
            <PillLink to={SIGNUP_URL} label="Start free" variant="accent" arrow />
            <PillLink to={DOCS_URL} label="Read the docs" variant="outline" />
          </div>
        </div>
      </div>
      <div className="shell">
        <span className="rule" />
      </div>
    </section>
  );
}
